import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IRouteReducerSliceStateInit } from "../slice_interface";
import { IMembershipExtensionListingResponseData } from "@/api_framework/api_modals/MembershipExtension";

export interface IMembershipExtensionState {
  membershipExtensionList: IMembershipExtensionListingResponseData[] | null;
}

export interface IMembershipExtensionInitialState extends IRouteReducerSliceStateInit {
  state: IMembershipExtensionState;
}

const initialState: IMembershipExtensionInitialState = {
  state: {
    membershipExtensionList: [],
  },
};

const membershipExtensionSlice = createSlice({
  name: "membership_extension_slice",
  initialState: initialState,
  reducers: {
    setMembershipExtensionList: (
      state,
      action: PayloadAction<{
        data: IMembershipExtensionListingResponseData[];
      }>,
    ) => {
      state.state.membershipExtensionList = action.payload.data;
    },
  },
});

export const { setMembershipExtensionList } = membershipExtensionSlice.actions;
export default membershipExtensionSlice.reducer;
